<template>
<!-- Page Content -->
<div id='page-wrapper'>
  <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
  <div class='container-fluid'>
    <div class='row'>
      <div class='col-lg-12'>
        <h1 class='page-header'>مراجعة</h1>
      </div>
      <!-- /.col-lg-12 -->
    </div>
    <!-- /.row -->
    <div class='row'>
      <div class='col-lg-12'>
        <div class='panel panel-default'>
          <div class='panel-heading'>
            هنا يتم مراجعة مدخلات النظام للتأكد من صحتها [ الاجمالى {{total}} جنيه] المصروفات {{this.TotalExpenses}} جنيه
            <div class="pull-left">
                <button @click='expenses()' type='button' class='btn btn-outline btn-primary btn-sm btn-block '  data-toggle='modal' data-target='#expenses'>
                المصروفات
                </button>
            </div>
          </div>
          <!-- /.panel-heading -->
          <div class='panel-body'>
            <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
              <ul v-if='validationErrors'>
                <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>
            <div class="row">
              <div class='col-lg-2 col-md-2 col-sm-6'>
                <label>الفرع</label>
                <select @change="UpdateCollectors()" class="form-control"  v-model="branch_id" >
                  <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-3 col-md-3 col-sm-6'>
                <tbDate :today='today' :mytitle='dateTitle' v-model= 'date' ></tbDate>
              </div>
              <div class='col-lg-3 col-md-3 col-sm-6'>
                <label>الفنى:</label>
                <select @change="changeCollectors()" class="form-control" style="padding: 0px" v-model="collector_id">
                  <option v-for="item in collectors" v-bind:key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-2 col-md-2 col-sm-6' >
                <span>&nbsp;</span>
                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                عرض
                </button>
              </div>
              <div class='col-lg-2 col-md-2 col-sm-6' >
                <span>&nbsp;</span>
                <button @click='resetFilter()' type='button' class='btn btn-outline btn-primary btn-md btn-block' data-toggle='modal' data-target='#ReviewForm'>
                مصادقة
                </button>
              </div>
            </div>
            <br>
            <div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>
                    <th style='text-align: center'>م</th>
                    <th style='text-align: center'>الكود</th>
                    <th style='text-align: center'>الاسم</th>
                    <th style='text-align: center'>المبلغ</th>
                    <th style='text-align: center'>المدفوع</th>
                    <th style='text-align: center'>المستخدم</th>
                    <th style='text-align: center'>النوع</th>
                    <th style='text-align: center'>الصنف</th>
                    <th style='text-align: center'>الفنى</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>
                    <td align='center'>{{index +1 }}</td>
                    <td align='center'>{{record.rec_id}}</td>
                    <td align='center'>{{record.customer_name}}</td>
                    <td align='center'>{{record.amount}}</td>
                    <td align='center'>{{record.payed}}</td>
                    <td align='center'>{{record.name}}</td>
                    <td align='center'>{{record.type}}</td>
                    <td align='center'>{{record.item}}</td>
                    <td align='center'>{{record.tec_name}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /.table-responsive -->
          </div>
          <!-- /.panel-body -->
        </div>
        <!-- /.panel -->
      </div>
      <!-- /.col-lg-12 -->
    </div>
  </div>
  <!-- Collectors Modal -->
  <div class='modal fade' id='ReviewForm' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
    <div class='modal-dialog  modal-lg'>
      <div class='modal-content'>
        <div class='modal-header'>
          <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
          <h4 class='modal-title' id='myModalLabel'>مصادقة اليومية الورقية مع النظام</h4>
        </div>
        <form role='form'>
          <div class='modal-body'>
            <div class='alert alert-danger alert-dismissable' v-if='CollectorsvalidationErrors'>
              <ul v-if='CollectorsvalidationErrors'>
                <li v-for='err in CollectorsvalidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>
            <div class='alert alert-success alert-dismissable' v-if='CollectorsSuccess'>
              {{CollectorsSuccess}}
            </div>
            <fieldset>
              <div class='form-group col-lg-12 col-sm-12'>
                <label>كود العميل:</label>
                <input v-model='rec_id' class='form-control' name='branchname' type='text'>
              </div>
            </fieldset>
            <div>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>الكود</th>
                      <th style='text-align: center'>الاسم</th>
                      <th style='text-align: center'>المبلغ</th>
                      <th style='text-align: center'>المدفوع</th>
                      <th style='text-align: center'>المستخدم</th>
                      <th style='text-align: center'>النوع</th>
                      <th style='text-align: center'>الصنف</th>
                      <th style='text-align: center'>الفنى</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in filterRecs' :key='index'>
                      <td align='center'>{{record.rec_id}}</td>
                      <td align='center'>{{record.customer_name}}</td>
                      <td align='center'>{{record.amount}}</td>
                      <td align='center'>{{record.payed}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.type}}</td>
                      <td align='center'>{{record.item}}</td>
                      <td align='center'>{{record.tec_name}}</td>
                    </tr>
                  </tbody>
                </table>
            </div>
          </div>
          <div class='modal-footer'>
            <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /Collectors modal -->
  <!-- DailyExpenses Modal -->
  <div class='modal fade' id='expenses' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
    <div class='modal-dialog  modal-lg'>
      <div class='modal-content'>
        <div class='modal-header'>
          <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
          <h4 class='modal-title' id='myModalLabel'>مصروفات اليومية</h4>
        </div>
        <DailyExpenses ref="DailyExpenses"> </DailyExpenses>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /DailyExpenses modal -->
  <!-- /.container-fluid -->
</div>
</template>
<script>
import axios from 'axios'
import DailyExpenses from './DailyExpenses'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate,
    DailyExpenses
  },
  name: 'DailyReview',
  data () {
    return {
      types: [
        {id: 0, name: 'الكل'},
        {id: 1, name: 'سداد قسط فلتر'},
        {id: 2, name: 'تغيير شمع وسداد'},
        {id: 3, name: 'عرض جديد'},
        {id: 4, name: 'طلب صيانة'}
      ],
      type_id: 0,
      TotalExpenses: 0,
      total: 0,
      rec_id: null,
      emptyRec: [{id: 0, name: ''}],
      sort: 'cash_receipts.id',
      today: true,
      dateTitle: 'التاريخ',
      date: '',
      validationErrors: '',
      records: [],
      errorShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      CollectorsSuccess: '',
      CollectorsvalidationErrors: '',
      branches: {},
      branch_id: 0,
      modelCollectors: {},
      collectors: {},
      collector_id: 0,
      modelCollectorId: '',
      cashReceipts: '',
      id: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
    this.UpdateCollectors()
  },
  computed: {
    filterRecs () {
      if (this.records.length > 0) {
        return this.records.filter(item => item.rec_id === parseInt(this.rec_id))
      } else {
        return []
      }
    }
  },
  methods: {
    resetFilter () {
      this.rec_id = null
    },
    UpdateCollectors () {
      this.collector_id = 0
      this.records = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.collectors = this.branches[i].collectors
        this.collectors.unshift(this.emptyRec)
      }
    },
    changeCollectors () {
      this.records = ''
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-daily-review-data', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        tec_id: this.collector_id,
        sort: this.sort,
        date: this.date
      })
        .then(({ data }) => {
          this.records = data.date
          this.TotalExpenses = data.TotalExpenses
          this.total = 0
          var i = 0
          for (i in this.records) { this.total += this.records[i].payed }
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ===========================================================
    saveData () {
      let Receipts = []
      this.CollectorsSuccess = ''
      this.CollectorsvalidationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'set-distributed-receipts', {
        token: localStorage.getItem('token'),
        CollectorId: this.modelCollectorId,
        folderDate: this.folder_date,
        receipts: Receipts
      })
        .then(res => {
          this.isLoadingSave = false
          this.CollectorsSuccess = 'تم الحفظ بنجاح'
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.CollectorsvalidationErrors = err.response.data.errors
          this.isLoadingSave = false
        })
    },
    // ===========================================================
    expenses () {
      let i = this.collectors.findIndex(x => x.id === parseInt(this.collector_id))
      if (i > -1) {
        this.$refs.DailyExpenses.loadPage(this.date, this.collector_id, this.collectors[i].name)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts/Daily/DailyReview.vue